import { render, staticRenderFns } from "./BadgeStatusOperator.vue?vue&type=template&id=04d38a32&"
import script from "./BadgeStatusOperator.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusOperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports